import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
// import CssBaseline from '@material-ui/core/CssBaseline';
import STLViewer from 'stl-viewer';
import { Grid } from '@material-ui/core';
// import axios, { AxiosResponse } from 'axios';

export interface StlViewerPageViewprops {
    signedUrlStl: Array<string>;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
    })
);

const StlViewerPageView: React.StatelessComponent<StlViewerPageViewprops> = (props) => {
    const classes = useStyles({});

    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" spacing={2}>
                {props.signedUrlStl.map((url) => (
                    <Grid item xs={12} sm={12} md={6}>
                        <div style={{ margin: 'auto' }}>
                            <STLViewer
                                model={url}
                                width={512}
                                height={288}
                                modelColor="#B92C2C"
                                backgroundColor="#EAEAEA"
                                rotate
                            />
                        </div>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};
export default StlViewerPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/StlViewerPageView.tsx